export const REQUEST_PORTFOLIO_ACTION = {
  CONNECT_PLAID: "connect_plaid",
  SCREENSHOT_RECOGNIZED: "screenshot_recognized",
  PDF_RECOGNIZED: "pdf_recognized",
  SKIPPED: "skipped",
  FEEDBACK: "feedback",
} as const;

export type RequestPortfolioAction =
  (typeof REQUEST_PORTFOLIO_ACTION)[keyof typeof REQUEST_PORTFOLIO_ACTION];

export type RequestPortfolioCardAction = RequestPortfolioAction;
